import { TicketSortDirection } from "@jugl-web/rest-api/tickets/models/common-types/TicketSortDirection";
import { Popover, PopoverProps, ListBox, ListBoxItem } from "@jugl-web/ui-kit";
import { FC, ReactNode, useMemo } from "react";
import { ReactComponent as AscIcon } from "./assets/asc.svg";
import { ReactComponent as DescIcon } from "./assets/desc.svg";

interface SortOptionValue {
  id: TicketSortDirection;
  label: string;
  helperText: string;
  icon: ReactNode;
}

export interface TicketSortPickerPopoverProps
  extends Pick<PopoverProps, "renderTrigger"> {
  sort: TicketSortDirection;
  onSortChange: (sort: TicketSortDirection) => void;
}

export const TicketSortPickerPopover: FC<TicketSortPickerPopoverProps> = ({
  sort,
  onSortChange,
  renderTrigger,
}) => {
  const items = useMemo<ListBoxItem<SortOptionValue>[]>(
    () => [
      {
        id: "asc",
        value: {
          id: "asc",
          label: "Ascending",
          helperText: "Earliest at the top",
          icon: <AscIcon />,
        },
      },
      {
        id: "desc",
        value: {
          id: "desc",
          label: "Descending",
          helperText: "Newest at the top",
          icon: <DescIcon />,
        },
      },
    ],
    []
  );

  return (
    <Popover
      placement="bottom-end"
      className="w-[220px] p-1.5"
      renderTrigger={renderTrigger}
    >
      {({ onClose }) => (
        <ListBox
          items={items}
          selectionBehavior={{ mode: "single", canToggle: false }}
          buttonType="radio"
          defaultSelectedIds={[sort]}
          itemSize="2xl"
          spaceBetweenItems="compact"
          renderStartIcon={(item) => item.value.icon}
          renderLabel={(item) => (
            <span className="font-medium">{item.value.label}</span>
          )}
          renderSecondaryText={(item) => item.value.helperText}
          onSelect={(item) => {
            onSortChange(item.value.id);
            onClose();
          }}
        />
      )}
    </Popover>
  );
};
